module.exports = __webpack_public_path__ + "img/tit.86778da3.png";